import { useForm } from "@mantine/form";
import { useState } from "react";
import { useNavigate, useParams } from "react-router";

import { validateRequired } from "../../utils/validations";
import { Button, Loader, Select, Textarea } from "@mantine/core";
import CustomDatePicker from "../common/Inputs/CustomDatePicker";
import dayjs from "dayjs";
import { createWorkPermit } from "../../api/workPermitApi";
import { updateNotification } from "@mantine/notifications";
import styled from "styled-components";
import { theme } from "../../theme";

const WorkPermitCreatePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const form = useForm({
    initialValues: {
      start: undefined,
      end: undefined,
      type: "",
      note: "",
    },
    validate: {
      start: validateRequired,
      end: validateRequired,
      type: validateRequired,
    },
  });

  const handleSubmit = async (values: any) => {
    const payload = {
      employeeId: id,
      start: dayjs(values.start).toDate().toISOString(),
      end: dayjs(values.end).toDate().toISOString(),
      type: values.type,
      note: values.note,
    };

    setIsLoading(true);
    try {
      const { data }: any = await createWorkPermit({
        ...payload,
      });

      updateNotification(data?.success);
      navigate(`/employees/${id}`, { state: { tab: "work-permits" } });
    } catch (error) {
      console.error("Error:", error);    
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageWrapper>
      <Header>
        <Title>Yeni İzin Oluştur</Title>
        <BackButton onClick={() => navigate(`/employees/${id}`, { state: { tab: "work-permits" } })}>
          ← Geri Dön
        </BackButton>
      </Header>

      <FormCard>
        <form
          style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          onSubmit={form.onSubmit(handleSubmit)}
        >
          <CustomDatePicker
            label="İzin Başlangıç Tarihi"
            placeholder="Tarih Seçiniz."
            w={"100%"}
            size="md"
            {...form.getInputProps("start")}
          />
          <CustomDatePicker
            label="İzin Bitiş Tarihi"
            placeholder="Tarih Seçiniz."
            minDate={form.values.start}
            w={"100%"}
            size="md"
            {...form.getInputProps("end")}
          />
          <Select
            label="İzin Tipi"
            placeholder="Seçiniz."
            size="md"
            data={[
              { value: "paid", label: "Ücretli" },
              { value: "unpaid", label: "Ücretsiz" },
            ]}
            {...form.getInputProps("type")}
          />
          <Textarea
            label="Notlar"
            placeholder="İzin için not girebilirsiniz."
            autosize
            minRows={3}
            maxRows={3}
            {...form.getInputProps("note")}
          />

          <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
            <Button
              variant="default"
              onClick={() => navigate(`/employees/${id}`, { state: { tab: "work-permits" } })}
              disabled={isLoading}
            >
              Vazgeç
            </Button>
            <Button
              type="submit"
              color={theme.colors.brand.normal}
              radius={10}
              disabled={!form.isDirty() || isLoading}
            >
              {isLoading ? <Loader color="white" size={20} /> : "Oluştur"}
            </Button>
          </div>
        </form>
      </FormCard>
    </PageWrapper>
  );
};

export default WorkPermitCreatePage;

const PageWrapper = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.div`
  font-weight: 600;
  color: black;
  font-size: 20px;
  line-height: 24px;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  font-size: 14px;
  &:hover {
    color: black;
  }
`;

const FormCard = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 24px;
  max-width: 600px;
`;